import * as React from 'react';
import { ListItem } from '../ListItem';
import * as styles from './Categories.css';

interface IProps {
  categories: Array<string>;
}

export const Categories = (props: IProps) => {
  const { categories } = props;

  const categoriesList = categories.map((category, key) => (
    <li key={key} className={styles['item']}>
      {category}
    </li>
  ));

  return <ListItem title="Категории" content={<ul className={styles['list']}>{categoriesList}</ul>} />;
};
